export const getCorrectAnswer = (event, $answer) => {
  $answer = $answer || event.currentTarget.closest('.js-answer');
  return $answer.correct;
};
